module.exports = __webpack_public_path__ + "static/media/hiper.b6cfe25e.png";